import styled from "styled-components";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import React, { useState } from 'react'

function Search() {

    const [input, setInput] = useState("")
    const navigate = useNavigate();

    const submitHandler=(e)=>{
        e.preventDefault();
        navigate('/searched/' + input)

    }




  return (

    <FormStyled onSubmit={submitHandler}>
        <FaSearch/>
        <input 
        type="text"
        onChange={(e)=> setInput(e.target.value)}
        value={input}/>
    </FormStyled>
  )
}


const FormStyled = styled.form`
margin: 2rem 20rem;
position: relative;
input {
  border: none;
  background: linear-gradient(35deg, #494949, #313131);
  font-size: 1.5rem;
  color: white;
  padding: 1rem 3rem;
  border: none;
  border-radius: 1rem;
  outline: none;
  width: 100%;
}

svg {
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(100%, -50%);
  color: white;
`
  
export default Search